import { HttpQueueRecordReport } from '../../../../domain/http';
import { HttpClientAdapter } from '../../../../infra/adapters';
import { ReportQueueRecordsData } from '../../../../application/data';

export const MakeReportQueueRecords = () => {
  const httpClientAdapter = new HttpClientAdapter();
  const httpClient = new HttpQueueRecordReport(httpClientAdapter);
  return new ReportQueueRecordsData(httpClient);
};
